import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";

export default function ChangePasswordForm({ onDone }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password changed");
      onDone();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  const inputCls =
    "w-full rounded-xl border border-white/10 bg-ink px-4 py-3 text-sm text-white outline-none placeholder:text-white/30 focus:border-gold";

  return (
    <form data-testid="change-password-form" onSubmit={submit} className="mb-10 grid gap-3 rounded-2xl border border-gold/20 bg-coal p-5 sm:grid-cols-[1fr_1fr_auto]">
      <input data-testid="change-password-current" type="password" required placeholder="Current password" value={current} onChange={(e) => setCurrent(e.target.value)} className={inputCls} />
      <input data-testid="change-password-new" type="password" required minLength={8} placeholder="New password (min 8)" value={next} onChange={(e) => setNext(e.target.value)} className={inputCls} />
      <button data-testid="change-password-submit" disabled={busy} className="rounded-full bg-gold px-6 py-3 text-sm font-extrabold text-black disabled:opacity-70">
        Save
      </button>
    </form>
  );
}
